import { Component, OnInit, Renderer2, ViewEncapsulation, ViewChild } from '@angular/core';
import { LocalStorageService } from '../../../services/local-storage-service/local-storage.service';
import { WardsService } from '../../../services/wards-service/wards.service';
import { UserService } from '../../../services/user/user-service/user.service';
import { UserContext } from '../../../models/user-context';
import { Student } from '../../../models/student';
import { AppSettings } from '../../../utils/app-settings';
import { ComponentBase } from '../../../base-classes/componet-base';
import { NgProgressComponent } from 'ngx-progressbar';
import { LoaderService } from 'src/app/services/loader/loader.service';


@Component({
  selector: 'app-web-authorized-layout',
  templateUrl: './web-authorized-layout.component.html',
  styleUrls: ['./web-authorized-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WebAuthorizedLayoutComponent extends ComponentBase {

  constructor(private wardsService: WardsService
    , private localStorageService: LocalStorageService
    , private userService: UserService
    , private loaderService: LoaderService
    , private renderer: Renderer2) {
    super();

  }


  @ViewChild("ngProgress", { static: false }) progressBar: NgProgressComponent;

  public showMenu: boolean = true;
  ngOnInit() {
    let sub = this.userService.getLoggedInUser()
      .subscribe(user => {
        if (!user.students || user.students.length == 0) {
          window.location.href = "/";
          return;
        }
        let user_context: UserContext = this.localStorageService.getItem(AppSettings.LocalStorageUserContextKey);
        let ward: Student;
        this.wardsService.setWards(user.students);
        if (user_context && user.person.person_id == user_context.person_id) {
          ward = user.students.find(o => o.student_id == user_context.student_id);
        }
        else {
          ward = user.students[0];
          let user_context: UserContext = new UserContext();
          user_context.person_id = user.person.person_id;
          user_context.student_id = ward.student_id;
          this.localStorageService.setItem(AppSettings.LocalStorageUserContextKey, user_context);
        }
        this.wardsService.setWard(ward);
      });
    this.addSubscription(sub);
  }

  ngAfterViewInit() {
    let sub2 = this.loaderService.showLoader$
      .subscribe(res => {
        if (res) {
          this.progressBar.start();
        } else {
          this.progressBar.complete();
        }
      });
    this.addSubscription(sub2);
  }

  onMenuToggle() {
    if (this.showMenu) {
      this.renderer.addClass(document.body, "menu-clicked");
    }
    else {
      this.renderer.removeClass(document.body, "menu-clicked");
    }
    this.showMenu = !this.showMenu;
  }

  onMenuClicked() {
    if (window.innerWidth && window.innerWidth < 1070) {
      this.renderer.removeClass(document.body, "menu-clicked");
      this.showMenu = !this.showMenu;
    }
  }

}
